<template>
  <div data-testid="footer-social-media" class="text-center md:text-left">
    <p
      class="text-base mb-0 font-bold uppercase text-mouse"
      role="heading"
      aria-level="2"
    >
      {{ $t('general/footer/block/social_media/title') }}
    </p>
    <div
      class="flex flex-wrap justify-center md:justify-start gap-x-6 gap-y-4 mt-4"
    >
      <div v-for="socialMedia in socialMediaProfiles" :key="socialMedia.name">
        <a
          :href="socialMedia.link"
          target="_blank"
          rel="noopener"
          :aria-label="socialMedia.name"
          :data-testid="`social-${socialMedia.name}`"
        >
          <fa-icon
            :icon="socialMedia.icon"
            class="size-8 md:size-6 text-rhino"
            aria-hidden="true"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faDiscord,
  faFacebook,
  faInstagram,
  faTiktok,
  faXTwitter,
} from '@fortawesome/free-brands-svg-icons';

export interface SocialLink {
  name: string;
  link: string;
  icon: IconDefinition;
}

const { locale } = useI18n();

const socialMediaProfiles = computed<SocialLink[]>(() => [
  {
    name: 'facebook',
    icon: faFacebook,
    link:
      locale.value === 'de'
        ? 'https://www.facebook.com/gportalde'
        : 'https://www.facebook.com/gportalcom',
  },
  {
    name: 'x',
    icon: faXTwitter,
    link:
      locale.value === 'de'
        ? 'https://x.com/gportalde'
        : 'https://x.com/gportalint',
  },
  {
    name: 'instagram',
    icon: faInstagram,
    link: 'https://www.instagram.com/gportal_official/',
  },
  {
    name: 'tiktok',
    icon: faTiktok,
    link: 'https://www.tiktok.com/@gportal_official',
  },
  {
    name: 'discord',
    icon: faDiscord,
    link: 'https://discord.gg/gportal',
  },
]);
</script>

<style scoped></style>
